import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { plansof } from '@/utils/chain';
import { mapGetters } from 'vuex';
import { isInrCurrency } from '@/utils/currency';
import { ACCOUNT_SALE_CHANNEL } from '@/common/constants';
import mx from './mx.vue';
import { couponFetchStatus } from '../../coupon/helper/constant';
import { isIncreasePriceForPH } from '@/common/hardcode';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';
import store from '@/store';
import _ from 'lodash';

export default {
  mixins: [mx],
  computed: {
    ...mapGetters([
      'boughtPlans',
      'getSelectedPlans',
      'cartFingerPrint',
      'discountWithAmountMap',
      'basicConfig',
      'currentEditPlan',
      'isMultipleCoupon',
      'haveAppliedThresholdCoupon',
      'getBoughtBasePlanInfo',
      'verifyCouponStatus',
      'appliedPlans4ThresholdCoupon'
    ]),
    haveUsedThresholdCouponPlans4CurrentCart() {
      const selectedPlanTypes = this.getSelectedPlans.map(p => p?.type);
      return _.some(this.appliedPlans4ThresholdCoupon, (p) => _.includes(selectedPlanTypes, p?.type));
    },
    hasOneTimeWebinar() {
      return this.getSelectedPlans.find(p => p.billing_cycle === BILLING_CYCLE.ONE_TIME && p.type === planTypes.WEBINAR);
    },
    hasPPA(){
      return this.getSelectedPlans.some(x => [planTypes.EVENT_SAAS, planTypes.EVENT_SAAS_CORE].includes(x.type) && x.isPPA);
    },
    condition_ZOOM_786892() {
      if (!this.$isEnabled('enableProrated')) return false; // optimizely control
      if (isIncreasePriceForPH()) return false;//php increasePrice(custom price)
      // match conditions
      // no master/sub account
      if (this.$config('isMasterOrSubAccount')) return false;
      if (this.basicConfig?.salesChannel !== ACCOUNT_SALE_CHANNEL.ONLINE) return false; // no non-online sales channel
      if (this.$context.is.delta) return false; // no delta
      if (!this.mx_prorated4SupportedCouponCase && (this.discountWithAmountMap?.totalDiscount > 0 || this.basicConfig?.hasAccountDiscount || this.verifyCouponStatus === couponFetchStatus.pending)) return false; // no discount
      if (this.isMultipleCoupon) return false; // multiple coupon case
      if (this.haveUsedThresholdCouponPlans4CurrentCart) return false; // have applied threshold coupon
      if (isInrCurrency()) return false; // no inr currency
      if (!this.boughtPlans.length) return false; // only paid users
      if (
        this.$context.is.buyNow ||
        this.$context.is.add2trial ||
        this.$context.is.buyTrial ||
        this.$context.is.basic2pro ||
        this.$context.is.downgrade ||
        this.$context.is.trial2paid
      ) {
        return false;
      } // no flows beyond scope

      //add url will also include trail2paid flow. trail2paid not support prorated now.
      const isCurrentFlowWithBaseFreeTrialPlanUpgraded = (store.getters?.addedTrialToPaidBasePlanList || []).length > 0;
      if (isCurrentFlowWithBaseFreeTrialPlanUpgraded && window.campaignFlags?.disableTrial2PaidPreviewHotFix !== true) {
        return false;
      }

      // block edit M2A with multiple bought plans which we cannot support for the moment
      // previously achieved via optimizely
      if(this.$context.is.edit){
        const isEditBasePlan = this.getBoughtBasePlanInfo.planType == this.currentEditPlan?.type;
        const isMoreThan1 = this.boughtPlans.length > 1;
        const isM2A = this.getSelectedPlans[0].billing_cycle === 'annual' && this.currentEditPlan?.billing_cycle === 'monthly';
        if(isEditBasePlan && isMoreThan1 && isM2A) return false;
      };
      if(this.$context.is.pro2biz){
        const isMoreThan1 = this.boughtPlans.length > 1;
        const boughtMeetingPlan = plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).get(0);
        const isM2A = this.getSelectedPlans[0].billing_cycle === 'annual' && boughtMeetingPlan?.billing_cycle === 'monthly';
        if(isMoreThan1 && isM2A) return false;
      }
      // exclude webinar one time
      if(this.hasOneTimeWebinar) return false;
      // exclude events & sessions PPA
      if(this.hasPPA) return false;
      // supported types so far
      const supportedTypes = [
        planTypes.ZOOM_MEETING,
        planTypes.CMR,
        planTypes.ZOOM_ROOMS,
        planTypes.ZOOM_SCHEDULER,
        planTypes.ZOOM_DOCS,
        planTypes.ZOOM_WHITEBOARD,
        planTypes.ZOOM_WHITEBOARD_PLUS,
        planTypes.ROOM_CONNECTOR,
        planTypes.TRANSLATION_CAPTIONS,
        planTypes.LARGE_MEETING,
        planTypes.WEBINAR,
        planTypes.EVENT_SAAS,
        planTypes.EVENT_SAAS_CORE,
        planTypes.VISITOR_MANAGEMENT,
        planTypes.WORKSPACE_RESERVATION,
        planTypes.CUSTOM_AVATARS,
        planTypes.ZOOM_CUSTOM_AI_COMPANION,
        planTypes.ZOOM_REVENUE_ACCELERATOR,
        planTypes.VIDEO_MANAGEMENT,
        planTypes.ZCM,
        planTypes.ZOOM_CLIPS,
        planTypes.ZOOM_PHONE,
        planTypes.ZOOM_PHONE$ADDITIONAL,
        planTypes.ZOOM_PHONE$ZPI,
        planTypes.ZOOM_PHONE$ZPA,
        planTypes.ZONE_PRO_PLUS,
        planTypes.ZOOM_ONE_BUNDLE,
        planTypes.ADDITIONAL_HOST,
        planTypes.ADDITIONAL_CO_EDITOR
      ];
      const isCartPlansInScope = this.getSelectedPlans.filter(x => !x.isVendorProduct).every(x => supportedTypes.includes(x.type));
      // only supported plans
      if(isCartPlansInScope){
        const isEditZPRelated = (this.$context.type == planTypes.ZOOM_PHONE || this.$context.type == planTypes.ZONE_PRO_PLUS || this.$context.type == planTypes.ZOOM_ONE_BUNDLE) && (this.$context.is.edit || this.$context.is.upsell);
        if(
          isEditZPRelated
        ) return this.mx_isMultipleIncremental;
        // except meeting of none pro/biz/school&campus
        if(plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).has() && !plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).category(
          ZOOM_MEETING_SUB_TYPES.PRO,
          ZOOM_MEETING_SUB_TYPES.BIZ,
          ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP
        ).has()) return false;  // FIXME: shall we add more edu plans
        // updated scope for sep. release
        if (this.$isEnabled('enableProrated_onlySingleLicenseIncrease')) {
          return this.mx_isSingleIncreaseLicense ? true : false;
        } else {
          return true;
        };
      }
      return false;
    },
    condition_OBT_4067() {
      if (!this.$isEnabled('enableProBizProrated')) return false;
      // match conditions
      if (this.basicConfig?.salesChannel !== ACCOUNT_SALE_CHANNEL.ONLINE) return false; // no non-online sales channel, talked with Yann that the preview API does not support non-online customers
      if (this.getSelectedPlans.length > 1) return false; // no more than one
      if (this.$context.is.delta) return false; // no delta
      if (this.discountWithAmountMap?.totalDiscount > 0 || this.basicConfig?.hasAccountDiscount) return false; // no discount
      if (isInrCurrency()) return false; // no inr currency
      const categories = ['pro', 'biz'];
      const isTargetPlans = plansof(this.getSelectedPlans)
        .type(planTypes.ZOOM_MEETING)
        .category(...categories)
        .has();
      if (!isTargetPlans) return false; // no more than pro/biz
      if (this.$context.is.add2cart) return true; // allows add2cart after all these conditions
      if (this.getSelectedPlans[0]?.category !== this.currentEditPlan?.category) return false; // no category change, e.g. from pro to biz
      const isSameBillingCycleAndIncreasedLicense = categories
        .map((category) => {
          const bought = plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).category(category);
          const boughtLicense = bought.clone().sum('license');
          const cur = plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).category(category);
          const curLicense = cur.clone().sum('license');
          const hasLicenseIncreased = curLicense > boughtLicense;
          const isSameBillingCycle = cur.clone().get(0)?.billing_cycle == bought.clone().get(0)?.billing_cycle;
          return hasLicenseIncreased && isSameBillingCycle;
        })
        .some((x) => x == true);
      if (this.$context.is.edit && isSameBillingCycleAndIncreasedLicense) return true; // allows edit with increasing only
      return false; // no any other cases
    },
  },
};
